import React from 'react';
import { config } from '../../Configs';
import { CAMPAIGN_REASON } from '../../Enums/campaigns';
import TriviaCopa60Game from './TriviaCopa60/Game';

const Game = props => {
  const getCampaignGameComponent = () => {
    switch (config.campaign.name) {
      case CAMPAIGN_REASON.COPA60:
        return <TriviaCopa60Game {...props} />;
      default:
        if (props.setOpenGame) {
          props.setOpenGame(false);
        }

        return <></>;
    }
  };

  return <>{getCampaignGameComponent()}</>;
};
export default Game;
